import React, { useState, useEffect } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { getUsuarios, normalizar, getLogoBase64 } from '../lib/db';

const hace50hrs = new Date(new Date() - 50 * 60 * 60 * 1000);
const hace72hrs = new Date(new Date() - 72 * 60 * 60 * 1000);
const hace96hrs = new Date(new Date() - 96 * 60 * 60 * 1000);

const viajesHistoricos = [];

const categoriasGasto = ['Combustible', 'Casetas', 'Comida', 'Mecánico', 'Hospedaje', 'Otro'];

export default function Reportes({ viajePreseleccionado, setViajePreseleccionado, alerts, viajesDB, empresaId, empresa }) {
  const [periodo, setPeriodo] = useState('semana');
  const [filtroTexto, setFiltroTexto] = useState('');
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [filtroCliente, setFiltroCliente] = useState('');
  const [filtroUsuario, setFiltroUsuario] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [viajeDetalle, setViajeDetalle] = useState(null);
  const [detalleTab, setDetalleTab] = useState('bitacora');
  const [showNuevoGasto, setShowNuevoGasto] = useState(false);
  const [nuevoGasto, setNuevoGasto] = useState({ descripcion: '', monto: '', categoria: 'Combustible', comentario: '' });
  const [viajes, setViajes] = useState(viajesHistoricos);
  const [listaUsuarios, setListaUsuarios] = useState([]);

  useEffect(() => {
    setViajes([...viajesHistoricos, ...(viajesDB || [])]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viajesDB?.length]);

  const [editandoHitoR, setEditandoHitoR] = useState(null);
  const [editHitoDataR, setEditHitoDataR] = useState({});
  const [showNuevoHitoR, setShowNuevoHitoR] = useState(false);
  const [nuevoHitoR, setNuevoHitoR] = useState('');
  useEffect(() => {
    const cargar = async () => {
      if (!empresaId) return;
      const { data } = await getUsuarios(empresaId);
      if (data) setListaUsuarios(data);
    };
    cargar();
  }, [empresaId]);

  useEffect(() => {
    if (viajePreseleccionado) {
      const encontrado = viajes.find(v => v.id === viajePreseleccionado.id);
      setViajeDetalle(encontrado ? encontrado : { ...viajePreseleccionado, hitos: viajePreseleccionado.hitos || [], gastos: viajePreseleccionado.gastos || [], duracion: '—', alertas: 0 });
      setDetalleTab('bitacora');
      if (setViajePreseleccionado) setViajePreseleccionado(null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viajePreseleccionado]);

  const ahora = new Date();
  const inicioFiltro = periodo === 'dia' ? new Date(ahora - 24*60*60*1000) :
    periodo === 'semana' ? new Date(ahora - 7*24*60*60*1000) :
    periodo === 'mes' ? new Date(ahora - 30*24*60*60*1000) : null;

  const viajesFiltrados = viajes.filter(v => {
    if (inicioFiltro && fechaInicio === '' && fechaFin === '') {
      const fechaViaje = new Date(v.created_at || v.salida || 0);
      if (fechaViaje < inicioFiltro) return false;
    }
    if (fechaInicio && new Date(v.created_at || v.salida || 0) < new Date(fechaInicio)) return false;
    if (fechaFin && new Date(v.created_at || v.salida || 0) > new Date(fechaFin + 'T23:59:59')) return false;
    return (
    (!filtroTexto ||
      normalizar(v.numero).includes(normalizar(filtroTexto)) ||
      normalizar(v.carrier).includes(normalizar(filtroTexto)) ||
      normalizar(v.cliente).includes(normalizar(filtroTexto)) ||
      normalizar(v.ruta).includes(normalizar(filtroTexto)) ||
      normalizar(v.unidad).includes(normalizar(filtroTexto)) ||
      normalizar(v.placas).includes(normalizar(filtroTexto)) ||
      normalizar(v.caja).includes(normalizar(filtroTexto)) ||
      normalizar(v.conductor).includes(normalizar(filtroTexto))
    ) &&
    (!filtroUsuario || v.usuario_nombre?.toLowerCase().includes(filtroUsuario.toLowerCase()))
    );
  });

  const totalGastosPeríodo = viajesFiltrados.reduce((a, v) => a + (v.gastos || []).reduce((b, g) => b + parseFloat(g.monto || 0), 0), 0);
  const kmTotales = viajesFiltrados.reduce((a, v) => a + parseFloat(v.kmRecorridos || v.km_recorridos || 0), 0);
  const costoPorKm = kmTotales > 0 ? (totalGastosPeríodo / kmTotales).toFixed(2) : '—';
  const costoPromedio = viajesFiltrados.length > 0 ? (totalGastosPeríodo / viajesFiltrados.length).toFixed(2) : '—';
  const incidencias = viajesFiltrados.filter(v => v.estado === 'incomplete').length;
  const totalViajes = viajesFiltrados.length;

  const calcularEsperaMinutos = (hitos) => {
    if (!hitos || hitos.length === 0) return null;
    const parse = (h) => {
      if (!h || !h.hora) return null;
      const p = h.hora.split(':').map(Number);
      if (p.length < 2 || isNaN(p[0]) || isNaN(p[1])) return null;
      const d = new Date(); d.setHours(p[0], p[1], 0, 0); return d;
    };
    const t1 = parse(hitos.find(h => h.nombre === 'Llegada a carga'));
    const t2 = parse(hitos.find(h => h.nombre === 'En movimiento'));
    const t3 = parse(hitos.find(h => h.nombre === 'Llegada a descarga'));
    const t4 = parse(hitos.find(h => h.nombre === 'Completado'));
    let total = 0;
    if (t1 && t2 && t2 > t1) total += (t2 - t1) / 60000;
    if (t3 && t4 && t4 > t3) total += (t4 - t3) / 60000;
    return total > 0 ? total : null;
  };

  const formatEspera = (mins) => mins < 60 ? `${Math.round(mins)} min` : `${(mins/60).toFixed(1)} hrs`;
  const viajesConEspera = viajesFiltrados.filter(v => calcularEsperaMinutos(v.hitos) !== null);
  const esperaPromedio = viajesConEspera.length > 0
    ? formatEspera(viajesConEspera.reduce((a, v) => a + calcularEsperaMinutos(v.hitos), 0) / viajesConEspera.length)
    : '—';

  const agrupar = (campo) => {
    const grupos = {};
    viajesFiltrados.forEach(v => {
      const key = v[campo] || 'Sin definir';
      if (!grupos[key]) grupos[key] = { viajes: 0, gastos: 0, km: 0, espera: [], incidencias: 0 };
      grupos[key].viajes++;
      grupos[key].gastos += (v.gastos || []).reduce((a, g) => a + parseFloat(g.monto || 0), 0);
      grupos[key].km += parseFloat(v.kmRecorridos || v.km_recorridos || 0);
      grupos[key].incidencias += v.estado === 'incomplete' ? 1 : 0;
      const e = calcularEsperaMinutos(v.hitos);
      if (e) grupos[key].espera.push(e);
    });
    return Object.entries(grupos).map(([nombre, d]) => ({
      nombre, viajes: d.viajes, gastos: d.gastos, incidencias: d.incidencias,
      costoPromedio: d.viajes > 0 ? `$${(d.gastos/d.viajes).toLocaleString('es-MX', {maximumFractionDigits:0})}` : '—',
      esperaPromedio: d.espera.length > 0 ? formatEspera(d.espera.reduce((a,b) => a+b,0) / d.espera.length) : '—',
    })).sort((a, b) => b.viajes - a.viajes);
  };

  const exportarCSV = () => {
    const headers = ['Viaje','Factura','Carrier','Conductor','Ejecutivo','Cliente','Ruta','Duración','Gastos','Alertas','Estado'];
    const rows = viajesFiltrados.map(v => {
      const gastoTotal = (v.gastos || []).reduce((a, g) => a + parseFloat(g.monto || 0), 0);
      return [v.numero, v.factura || '—', v.carrier, v.conductor, v.usuario_nombre || '—', v.cliente, v.ruta, v.duracion || '—', `$${gastoTotal.toFixed(2)}`, v.alertas, v.estado === 'completed' ? 'Completado' : 'Incompleto'];
    });
    const csv = [headers, ...rows].map(r => r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = `reporte_logiconnect_${new Date().toLocaleDateString('es-MX')}.csv`; a.click();
  };

const exportarViajePDF = async (v) => {
    const doc = new jsPDF({ format: 'letter' });
    const pageW = 215.9;
    const margin = 14;
    const fechaStr = new Date().toLocaleDateString('es-MX', { day: '2-digit', month: 'long', year: 'numeric' });

    // Encabezado con logo
    doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
    doc.text(fechaStr, margin, 14);

    if (empresa?.logo_url) {
      try {
        const base64 = await getLogoBase64(empresa.logo_url);
        if (base64) {
          const img = new Image();
          await new Promise(res => { img.onload = res; img.src = base64; });
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth || 400;
          canvas.height = img.naturalHeight || 200;
          canvas.getContext('2d').drawImage(img, 0, 0);
          const pngData = canvas.toDataURL('image/png');
          const ratio = (img.naturalWidth || 400) / (img.naturalHeight || 200);
          const logoH = 10; const logoW = logoH * ratio;
          doc.addImage(pngData, 'PNG', pageW - margin - logoW, 4, logoW, logoH);
        }
      } catch {}
    } else {
      doc.setFontSize(11); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text(empresa?.nombre || 'LogiConnect', pageW - margin - 50, 12);
    }

    doc.setDrawColor(180, 180, 180); doc.setLineWidth(0.3);
    doc.line(margin, 20, pageW - margin, 20);
    let y = 28;

    // Titulo
    doc.setFontSize(14); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
    doc.text('REPORTE DE VIAJE', margin, y); y += 6;
    doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(100, 100, 100);
    doc.text(`Viaje: ${v.numero}`, margin, y); y += 10;

    // Instrucciones especiales
    if (v.instrucciones_especiales) {
      doc.setFillColor(245, 245, 245);
      const instrLines = doc.splitTextToSize(v.instrucciones_especiales, pageW - margin * 2 - 8);
      const instrH = 14 + instrLines.length * 4;
      doc.roundedRect(margin, y, pageW - margin * 2, instrH, 2, 2, 'F');
      doc.setFontSize(7.5); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text('INSTRUCCIONES ESPECIALES', margin + 4, y + 6);
      doc.setFont('helvetica', 'normal'); doc.setTextColor(40, 40, 40);
      doc.text(instrLines, margin + 4, y + 12);
      y += instrH + 6;
    }

    // Origen y destino
    const colW = (pageW - margin * 2 - 8) / 2;
    const drawBloque = (titulo, lugar, direccion, x, startY) => {
      let sy = startY;
      doc.setFontSize(8); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text(titulo, x, sy); sy += 4;
      doc.setLineWidth(0.2); doc.setDrawColor(180, 180, 180);
      doc.line(x, sy, x + colW, sy); sy += 5;
      if (lugar) {
        doc.setFontSize(10); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
        doc.text(lugar, x, sy); sy += 5;
      }
      if (direccion) {
        doc.setFontSize(7); doc.setFont('helvetica', 'normal'); doc.setTextColor(80, 80, 80);
        const lines = doc.splitTextToSize(direccion, colW - 2);
        doc.text(lines, x, sy); sy += lines.length * 3.5 + 3;
      }
      return sy;
    };

    const origenStr = v.ruta?.split('\u2192')[0] || v.ruta?.split('->')[0] || '';
    const destinoStr = v.ruta?.split('\u2192')[1] || v.ruta?.split('->')[1] || '';
    const yO = drawBloque('ORIGEN', origenStr.trim(), v.direccion_origen, margin, y);
    const yD = drawBloque('DESTINO', destinoStr.trim(), v.direccion_destino, margin + colW + 8, y);
    y = Math.max(yO, yD) + 6;

    // Datos del viaje
    doc.setFontSize(8); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
    doc.text('FICHA DEL VIAJE', margin, y); y += 4;
    doc.setLineWidth(0.2); doc.setDrawColor(180, 180, 180);
    doc.line(margin, y, pageW - margin, y); y += 5;
    const campos = [
      v.carrier ? ['Carrier', v.carrier] : null,
      v.conductor ? ['Conductor', v.conductor] : null,
      v.cliente ? ['Cliente', v.cliente] : null,
      v.usuario_nombre ? ['Ejecutivo', v.usuario_nombre] : null,
      v.unidad ? ['Unidad', v.unidad] : null,
      v.placas ? ['Placas', v.placas] : null,
      v.caja ? ['Caja', v.caja] : null,
      v.factura ? ['Factura', v.factura] : null,
      v.duracion ? ['Duracion', v.duracion] : null,
    ].filter(Boolean);
    const cols = 3;
    const cw = (pageW - margin * 2) / cols;
    campos.forEach(([label, val], i) => {
      const cx = margin + (i % cols) * cw;
      const cy = y + Math.floor(i / cols) * 10;
      doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(100, 100, 100);
      doc.text(label, cx, cy);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor(0, 0, 0);
      doc.text(String(val), cx, cy + 4);
    });
    y += Math.ceil(campos.length / cols) * 10 + 6;

    // Mercancia
    if (v.descripcion_mercancia || v.peso_mercancia) {
      doc.setFontSize(8); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text('MERCANCIA', margin, y); y += 4;
      doc.setLineWidth(0.2); doc.setDrawColor(180, 180, 180);
      doc.line(margin, y, pageW - margin, y); y += 5;
      if (v.descripcion_mercancia) {
        doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(100, 100, 100);
        doc.text('Descripcion:', margin, y);
        doc.setFont('helvetica', 'normal'); doc.setFontSize(8); doc.setTextColor(0, 0, 0);
        doc.text(v.descripcion_mercancia, margin + 28, y); y += 5;
      }
      if (v.peso_mercancia) {
        doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(100, 100, 100);
        doc.text('Peso/Vol:', margin, y);
        doc.setFont('helvetica', 'normal'); doc.setFontSize(8); doc.setTextColor(0, 0, 0);
        doc.text(v.peso_mercancia, margin + 28, y); y += 5;
      }
      y += 4;
    }

    // Bitacora
    if (v.hitos?.length > 0) {
      doc.setFontSize(8); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text('BITACORA DE HITOS', margin, y); y += 4;
      autoTable(doc, {
        startY: y,
        head: [['Fecha', 'Hora', 'Hito', 'Ubicacion', 'Aprobado']],
        body: v.hitos.map(h => [h.fecha || '--', h.hora || '--', h.nombre, h.ubicacion || '--', h.aprobado ? 'Si' : 'No']),
        styles: { fontSize: 7, cellPadding: 2 },
        headStyles: { fillColor: [50, 50, 50], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 7 },
        alternateRowStyles: { fillColor: [248, 248, 248] },
        columnStyles: { 0: { cellWidth: 22 }, 1: { cellWidth: 14 }, 2: { cellWidth: 50 }, 4: { cellWidth: 14 } },
        margin: { left: margin, right: margin },
      });
      y = doc.lastAutoTable.finalY + 6;
    }

    // Gastos
    if (v.gastos?.length > 0) {
      const gastoTotal = v.gastos.reduce((a, g) => a + parseFloat(g.monto || 0), 0);
      doc.setFontSize(8); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text('GASTOS DEL VIAJE', margin, y); y += 4;
      autoTable(doc, {
        startY: y,
        head: [['Descripcion', 'Categoria', 'Monto (MXN)', 'Hora']],
        body: v.gastos.map(g => [g.descripcion, g.categoria, `$${parseFloat(g.monto).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`, g.fecha || '--']),
        foot: [['', 'TOTAL', `$${gastoTotal.toLocaleString('es-MX', { minimumFractionDigits: 2 })}`, '']],
        styles: { fontSize: 7, cellPadding: 2 },
        headStyles: { fillColor: [50, 50, 50], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 7 },
        footStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0], fontStyle: 'bold' },
        alternateRowStyles: { fillColor: [248, 248, 248] },
        columnStyles: { 2: { halign: 'right' } },
        margin: { left: margin, right: margin },
      });
    }

    // Footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(7); doc.setFont('helvetica', 'normal'); doc.setTextColor(150, 150, 150);
      doc.text(`${empresa?.nombre || 'LogiConnect'} · Pagina ${i} de ${pageCount}`, margin, 272);
    }

    doc.save(`reporte_viaje_${v.numero}_${new Date().toLocaleDateString('es-MX').replace(/\//g, '-')}.pdf`);
  };

  const exportarPDF = async () => {
    const doc = new jsPDF();
    const pageW = 210;
    const margin = 14;
    const fechaStr = new Date().toLocaleDateString('es-MX', { day: '2-digit', month: 'long', year: 'numeric' });

    // Encabezado
    doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
    doc.text(fechaStr, margin, 14);

    if (empresa?.logo_url) {
      try {
        const base64 = await getLogoBase64(empresa.logo_url);
        if (base64) {
          const img = new Image();
          await new Promise(res => { img.onload = res; img.src = base64; });
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth || 400;
          canvas.height = img.naturalHeight || 200;
          canvas.getContext('2d').drawImage(img, 0, 0);
          const pngData = canvas.toDataURL('image/png');
          const ratio = (img.naturalWidth || 400) / (img.naturalHeight || 200);
          const logoH = 10; const logoW = logoH * ratio;
          doc.addImage(pngData, 'PNG', pageW - margin - logoW, 4, logoW, logoH);
        }
      } catch {}
    } else {
      doc.setFontSize(11); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text(empresa?.nombre || 'LogiConnect', pageW - margin - 50, 12);
    }

    doc.setDrawColor(180, 180, 180); doc.setLineWidth(0.3);
    doc.line(margin, 20, pageW - margin, 20);

    doc.setFontSize(14); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
    doc.text('REPORTE DEL PERIODO', margin, 30);

    // Metricas
    doc.setFontSize(8); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
    doc.text('METRICAS', margin, 40);
    doc.setLineWidth(0.2); doc.setDrawColor(180, 180, 180);
    doc.line(margin, 42, pageW - margin, 42);

    const metricas = [
      ['Total de viajes', String(totalViajes)],
      ['Costo total', totalGastosPeríodo > 0 ? `$${totalGastosPeríodo.toLocaleString('es-MX', { maximumFractionDigits: 0 })}` : '--'],
      ['Costo por km', costoPorKm !== '--' ? `$${costoPorKm}/km` : '--'],
      ['Costo promedio por viaje', costoPromedio !== '--' ? `$${parseFloat(costoPromedio).toLocaleString('es-MX')}` : '--'],
      ['Espera promedio', esperaPromedio],
      ['Viajes con incidencias', `${incidencias}/${totalViajes}`],
    ];
    metricas.forEach(([label, val], i) => {
      const col = i % 3;
      const row = Math.floor(i / 3);
      const x = margin + col * 60;
      const y = 48 + row * 12;
      doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(100, 100, 100);
      doc.text(label, x, y);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor(0, 0, 0);
      doc.text(val, x, y + 4);
    });

    let y = 48 + Math.ceil(metricas.length / 3) * 12 + 6;

    // Viajes
    doc.setFontSize(8); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
    doc.text('VIAJES DEL PERIODO', margin, y); y += 4;
    autoTable(doc, {
      startY: y,
      head: [['Viaje', 'Carrier', 'Ejecutivo', 'Cliente', 'Ruta', 'Gastos', 'Estado']],
      body: viajesFiltrados.map(v => {
        const gastoTotal = (v.gastos || []).reduce((a, g) => a + parseFloat(g.monto || 0), 0);
        return [v.numero, v.carrier || '--', v.usuario_nombre || '--', v.cliente || '--', (v.ruta || '--').replace(/→/g, '->').replace(/\u2192/g, '->'), `$${gastoTotal.toLocaleString('es-MX', { minimumFractionDigits: 2 })}`, v.estado === 'completed' ? 'Completado' : v.estado === 'active' ? 'Activo' : 'Incompleto'];
      }),
      styles: { fontSize: 7.5, cellPadding: 3 },
      headStyles: { fillColor: [50, 50, 50], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 7.5 },
      alternateRowStyles: { fillColor: [248, 248, 248] },
      margin: { left: margin, right: margin },
    });

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(7); doc.setFont('helvetica', 'normal'); doc.setTextColor(150, 150, 150);
      doc.text(`${empresa?.nombre || 'LogiConnect'} · Pagina ${i} de ${pageCount}`, margin, 287);
    }

    doc.save(`reporte_periodo_${new Date().toLocaleDateString('es-MX').replace(/\//g, '-')}.pdf`);
  };

  const estadoColor = { completed: '#00e5a0', incomplete: '#ef4444', active: '#3b82f6' };
  const estadoLabel = { completed: 'Completado', incomplete: 'Incompleto', active: 'Activo' };
  const totalGastos = viajeDetalle?.gastos?.reduce((a, g) => a + parseFloat(g.monto || 0), 0) || 0;

  const agregarGasto = () => {
    if (!nuevoGasto.descripcion || !nuevoGasto.monto) return;
    const gasto = { id: Date.now(), ...nuevoGasto, fecha: new Date().toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) };
    const updated = viajes.map(v => v.id === viajeDetalle.id ? { ...v, gastos: [...v.gastos, gasto] } : v);
    setViajes(updated);
    setViajeDetalle({ ...viajeDetalle, gastos: [...viajeDetalle.gastos, gasto] });
    setNuevoGasto({ descripcion: '', monto: '', categoria: 'Combustible', comentario: '' });
    setShowNuevoGasto(false);
  };

  const eliminarGasto = (gastoId) => {
    const updated = viajes.map(v => v.id === viajeDetalle.id ? { ...v, gastos: v.gastos.filter(g => g.id !== gastoId) } : v);
    setViajes(updated);
    setViajeDetalle({ ...viajeDetalle, gastos: viajeDetalle.gastos.filter(g => g.id !== gastoId) });
  };

  const datos = {
    dia: { viajes: 2, completados: 2, tiempoPromedio: '3.3 hrs', kmTotal: 14820 },
    semana: { viajes: 5, completados: 4, tiempoPromedio: '3.8 hrs', kmTotal: 52400 },
    mes: { viajes: 22, completados: 20, tiempoPromedio: '4.1 hrs', kmTotal: 218600 },
    custom: { viajes: 8, completados: 7, tiempoPromedio: '3.9 hrs', kmTotal: 78300 },
  };
  const d = datos[periodo];

  const tipoLabel = { detencion_prolongada: 'Detención prolongada', velocidad_excesiva: 'Velocidad excesiva', desvio_ruta: 'Desviación de ruta', hito_no_confirmado: 'Hito no confirmado', llegada_proxima: 'Llegada próxima', sin_actualizacion: 'Sin actualización' };
  const coloresMotivo = { detencion_prolongada: '#ef4444', velocidad_excesiva: '#f59e0b', desvio_ruta: '#8b5cf6', hito_no_confirmado: '#3b82f6', llegada_proxima: '#00e5a0', sin_actualizacion: '#f59e0b' };
  const motivosConteo = (alerts || []).reduce((acc, a) => {
    const tipo = a.dismissed && a.motivo ? a.motivo : (a.tipo || 'Otro');
    acc[tipo] = (acc[tipo] || 0) + 1;
    return acc;
  }, {});
  const motivosData = Object.entries(motivosConteo).map(([tipo, cantidad]) => ({
    motivo: tipoLabel[tipo] || tipo, cantidad, color: coloresMotivo[tipo] || '#6b7280'
  })).sort((a, b) => b.cantidad - a.cantidad);
  const total = motivosData.reduce((a, b) => a + b.cantidad, 0) || 1;
const hitosDefaultR = ['Llegada a carga','En movimiento','Descanso','Detenida','Llegada a descarga','Completado','En espera de determinaciones'];

  const agregarHitoReporte = () => {
    if (!nuevoHitoR) return;
    const now = new Date();
    const hito = {
      nombre: nuevoHitoR,
      hora: now.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }),
      fecha: now.toLocaleDateString('es-MX', { weekday: 'short', day: '2-digit', month: '2-digit', year: '2-digit' }),
      ubicacion: '', comentario: '', aprobado: true, notificado: false
    };
    const updated = viajes.map(v => v.id === viajeDetalle.id ? { ...v, hitos: [...(v.hitos||[]), hito] } : v);
    setViajes(updated);
    setViajeDetalle({ ...viajeDetalle, hitos: [...(viajeDetalle.hitos||[]), hito] });
    setNuevoHitoR(''); setShowNuevoHitoR(false);
  };

  const eliminarHitoReporte = (idx) => {
    const hitos = viajeDetalle.hitos.filter((_, i) => i !== idx);
    const updated = viajes.map(v => v.id === viajeDetalle.id ? { ...v, hitos } : v);
    setViajes(updated);
    setViajeDetalle({ ...viajeDetalle, hitos });
  };

  const guardarEdicionHitoReporte = (idx) => {
    const hito = viajeDetalle.hitos[idx];
    const cambios = { hora: editHitoDataR.hora || hito.hora, fecha: editHitoDataR.fecha || hito.fecha, ubicacion: editHitoDataR.ubicacion ?? hito.ubicacion, comentario: editHitoDataR.comentario ?? hito.comentario };
    const hitos = viajeDetalle.hitos.map((h, i) => i === idx ? { ...h, ...cambios } : h);
    const updated = viajes.map(v => v.id === viajeDetalle.id ? { ...v, hitos } : v);
    setViajes(updated);
    setViajeDetalle({ ...viajeDetalle, hitos });
    setEditandoHitoR(null); setEditHitoDataR({});
  };
  if (viajeDetalle) {
    return (
      <div style={{ padding: '28px 32px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '28px' }}>
          <button onClick={() => setViajeDetalle(null)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '8px 14px', fontSize: '13px', cursor: 'pointer' }}>← Volver</button>
          <button onClick={() => exportarViajePDF(viajeDetalle)} style={{ background: 'transparent', border: '1px solid #3b82f6', color: '#3b82f6', borderRadius: '6px', padding: '8px 14px', fontSize: '13px', cursor: 'pointer' }}>PDF</button>
          <div>
            <span style={{ fontFamily: 'monospace', fontSize: '22px', fontWeight: '700', color: '#00e5a0' }}>{viajeDetalle.numero}</span>
            <span style={{ fontSize: '14px', color: '#9ca3af', marginLeft: '12px' }}>{viajeDetalle.ruta}</span>
          </div>
          <span style={{ fontSize: '12px', fontWeight: '600', padding: '4px 12px', borderRadius: '10px', background: `${estadoColor[viajeDetalle.estado]}18`, color: estadoColor[viajeDetalle.estado] }}>{estadoLabel[viajeDetalle.estado]}</span>
        </div>

        <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '24px', marginBottom: '20px' }}>
          <div style={{ fontSize: '13px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '16px' }}>Ficha del Viaje</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
            {[
              { label: 'Número de viaje', value: viajeDetalle.numero },
              { label: 'Número de factura', value: viajeDetalle.factura || '—' },
              { label: 'Carrier', value: viajeDetalle.carrier },
              { label: 'Conductor', value: viajeDetalle.conductor },
              { label: 'Cliente', value: viajeDetalle.cliente },
              { label: 'Ejecutivo', value: viajeDetalle.usuario_nombre || '—' },
              { label: 'Ruta', value: viajeDetalle.ruta },
              { label: 'Unidad', value: viajeDetalle.unidad || '—' },
              { label: 'Caja / Placas', value: `${viajeDetalle.caja || '—'} / ${viajeDetalle.placas || '—'}` },
              { label: 'Duración', value: viajeDetalle.duracion || '—' },
            ].map(item => (
              <div key={item.label}>
                <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>{item.label}</div>
                <div style={{ fontSize: '14px', fontWeight: '500', color: item.label === 'Ejecutivo' ? '#8b5cf6' : '#e8eaf0' }}>{item.value}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '20px', borderBottom: '1px solid #222730' }}>
          {[{ id: 'bitacora', label: 'Bitácora' }, { id: 'gastos', label: 'Gastos' }, { id: 'documentos', label: 'Documentos' }].map(tab => (
            <div key={tab.id} onClick={() => setDetalleTab(tab.id)}
              style={{ padding: '10px 20px', cursor: 'pointer', fontSize: '13px', fontWeight: '500', color: detalleTab === tab.id ? '#00e5a0' : '#6b7280', borderBottom: `2px solid ${detalleTab === tab.id ? '#00e5a0' : 'transparent'}`, marginBottom: '-1px' }}>
              {tab.label}
            </div>
          ))}
        </div>

{detalleTab === 'bitacora' && (
          <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
            <div style={{ padding: '14px 20px', borderBottom: '1px solid #222730', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>
                Diario del Viaje
                <span style={{ fontSize: '11px', color: '#6b7280', fontWeight: '400', marginLeft: '8px' }}>— edición sin notificación</span>
              </span>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <span style={{ fontSize: '11px', color: '#6b7280' }}>{viajeDetalle.hitos?.length || 0} eventos</span>
                <button onClick={() => setShowNuevoHitoR(true)} style={{ background: 'rgba(0,229,160,0.1)', border: '1px solid rgba(0,229,160,0.2)', color: '#00e5a0', borderRadius: '6px', padding: '4px 10px', fontSize: '11px', cursor: 'pointer', fontWeight: '600' }}>+ Agregar</button>
              </div>
            </div>
            {showNuevoHitoR && (
              <div style={{ padding: '12px 20px', borderBottom: '1px solid #222730', background: 'rgba(0,229,160,0.03)', display: 'flex', gap: '8px' }}>
                <select value={nuevoHitoR} onChange={e => setNuevoHitoR(e.target.value)}
                  style={{ flex: 1, background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 12px', color: '#e8eaf0', fontSize: '13px' }}>
                  <option value="">Seleccionar hito...</option>
                  {hitosDefaultR.map(h => <option key={h} value={h}>{h}</option>)}
                </select>
                <button onClick={agregarHitoReporte} style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '8px 14px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>Agregar</button>
                <button onClick={() => setShowNuevoHitoR(false)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '8px 14px', fontSize: '12px', cursor: 'pointer' }}>Cancelar</button>
              </div>
            )}
            {(!viajeDetalle.hitos || viajeDetalle.hitos.length === 0) && !showNuevoHitoR && (
              <div style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin hitos registrados</div>
            )}
            {(viajeDetalle.hitos || []).map((h, i) => {
              const editandoEste = editandoHitoR === i;
              return (
                <div key={i} style={{ padding: '16px 20px', borderBottom: '1px solid #222730', display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', flexShrink: 0 }}>
                    <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: 'rgba(0,229,160,0.1)', border: '1px solid #00e5a0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', color: '#00e5a0' }}>✓</div>
                    {i < (viajeDetalle.hitos?.length || 0) - 1 && <div style={{ width: '1px', height: '20px', background: '#222730' }}></div>}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', alignItems: 'center' }}>
                      <span style={{ fontSize: '14px', fontWeight: '600', color: '#e8eaf0' }}>{h.nombre}</span>
                      {editandoEste ? (
                        <div style={{ display: 'flex', gap: '6px' }}>
                        <input type="date" value={editHitoDataR.fecha ?? ''} onChange={e => setEditHitoDataR({...editHitoDataR, fecha: e.target.value})}
                        style={{ background: '#181c24', border: '1px solid #00e5a0', borderRadius: '6px', padding: '4px 8px', color: '#e8eaf0', fontSize: '12px', width: '140px', colorScheme: 'dark' }} />                          <input type="time" value={editHitoDataR.hora ?? h.hora ?? ''} onChange={e => setEditHitoDataR({...editHitoDataR, hora: e.target.value})}
                            style={{ background: '#181c24', border: '1px solid #00e5a0', borderRadius: '6px', padding: '4px 8px', color: '#e8eaf0', fontSize: '12px', width: '110px', colorScheme: 'dark' }} />
                        </div>
                      ) : (
                        <span style={{ fontSize: '11px', color: '#6b7280', fontFamily: 'monospace' }}>{h.fecha ? `${h.fecha} · ${h.hora}` : h.hora}</span>
                      )}
                    </div>
                    {editandoEste ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '8px' }}>
                        <input value={editHitoDataR.ubicacion ?? h.ubicacion ?? ''} onChange={e => setEditHitoDataR({...editHitoDataR, ubicacion: e.target.value})}
                          placeholder="Ubicación" style={{ background: '#181c24', border: '1px solid #00e5a0', borderRadius: '6px', padding: '4px 8px', color: '#e8eaf0', fontSize: '12px', width: '100%' }} />
                        <input value={editHitoDataR.comentario ?? h.comentario ?? ''} onChange={e => setEditHitoDataR({...editHitoDataR, comentario: e.target.value})}
                          placeholder="Comentario" style={{ background: '#181c24', border: '1px solid #00e5a0', borderRadius: '6px', padding: '4px 8px', color: '#e8eaf0', fontSize: '12px', width: '100%' }} />
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <button onClick={() => guardarEdicionHitoReporte(i)} style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '5px 12px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>💾 Guardar</button>
                          <button onClick={() => { setEditandoHitoR(null); setEditHitoDataR({}); }} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '5px 10px', fontSize: '12px', cursor: 'pointer' }}>Cancelar</button>
                        </div>
                      </div>
                    ) : (
                      <>
                        {h.ubicacion && <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>{h.ubicacion}</div>}
                        {h.comentario && <div style={{ fontSize: '12px', color: '#9ca3af', marginBottom: '6px' }}>{h.comentario}</div>}
                        <div style={{ display: 'flex', gap: '8px' }}>
                        {h.aprobado && <span style={{ fontSize: '10px', padding: '2px 8px', borderRadius: '10px', background: 'rgba(0,229,160,0.1)', color: '#00e5a0' }}>✓ Aprobado</span>}
                        {h.notificado && <span style={{ fontSize: '10px', padding: '2px 8px', borderRadius: '10px', background: 'rgba(59,130,246,0.1)', color: '#3b82f6' }}>📤 Cliente notificado</span>}               
                        </div>
                      </>
                    )}
                  </div>
                  {!editandoEste && (
                    <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
                      <button onClick={() => { setEditandoHitoR(i); setEditHitoDataR({}); }} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '4px 8px', fontSize: '11px', cursor: 'pointer' }}>✏️</button>
                      <button onClick={() => eliminarHitoReporte(i)} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '14px', padding: '4px' }}>🗑️</button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {detalleTab === 'gastos' && (
          <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
            <div style={{ padding: '14px 20px', borderBottom: '1px solid #222730', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>Gastos del Viaje</span>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <span style={{ fontSize: '13px', color: '#00e5a0', fontWeight: '700' }}>Total: ${totalGastos.toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN</span>
                <button onClick={() => setShowNuevoGasto(true)} style={{ background: 'rgba(0,229,160,0.1)', border: '1px solid rgba(0,229,160,0.2)', color: '#00e5a0', borderRadius: '6px', padding: '4px 10px', fontSize: '11px', cursor: 'pointer', fontWeight: '600' }}>+ Agregar</button>
              </div>
            </div>
            {showNuevoGasto && (
              <div style={{ padding: '16px 20px', borderBottom: '1px solid #222730', background: 'rgba(0,229,160,0.03)' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                  <div>
                    <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Descripción</label>
                    <input value={nuevoGasto.descripcion} onChange={e => setNuevoGasto({ ...nuevoGasto, descripcion: e.target.value })}
                      placeholder="Ej: Carga de diesel" style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Monto (MXN)</label>
                    <input type="number" value={nuevoGasto.monto} onChange={e => setNuevoGasto({ ...nuevoGasto, monto: e.target.value })}
                      placeholder="0.00" style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Categoría</label>
                    <select value={nuevoGasto.categoria} onChange={e => setNuevoGasto({ ...nuevoGasto, categoria: e.target.value })}
                      style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px' }}>
                      {categoriasGasto.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Comentario</label>
                  <input value={nuevoGasto.comentario} onChange={e => setNuevoGasto({ ...nuevoGasto, comentario: e.target.value })}
                    placeholder="Notas adicionales..." style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px' }} />
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={agregarGasto} style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>Guardar</button>
                  <button onClick={() => setShowNuevoGasto(false)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer' }}>Cancelar</button>
                </div>
              </div>
            )}
            {(!viajeDetalle.gastos || viajeDetalle.gastos.length === 0) && !showNuevoGasto && (
              <div style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin gastos registrados</div>
            )}
            {(viajeDetalle.gastos || []).map(g => (
              <div key={g.id} style={{ padding: '14px 20px', borderBottom: '1px solid #222730', display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{ width: '36px', height: '36px', borderRadius: '8px', background: 'rgba(0,229,160,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', flexShrink: 0 }}>
                  {g.categoria === 'Combustible' ? '⛽' : g.categoria === 'Casetas' ? '🛣️' : g.categoria === 'Comida' ? '🍽️' : g.categoria === 'Mecánico' ? '🔧' : g.categoria === 'Hospedaje' ? '🏨' : '📋'}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
                    <span style={{ fontSize: '13px', fontWeight: '600', color: '#e8eaf0' }}>{g.descripcion}</span>
                    <span style={{ fontSize: '14px', fontWeight: '700', color: '#00e5a0' }}>${parseFloat(g.monto).toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN</span>
                  </div>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <span style={{ fontSize: '11px', color: '#6b7280' }}>{g.categoria}</span>
                    {g.comentario && <span style={{ fontSize: '11px', color: '#6b7280' }}>· {g.comentario}</span>}
                    <span style={{ fontSize: '11px', color: '#6b7280' }}>· {g.fecha}</span>
                  </div>
                </div>
                <button onClick={() => eliminarGasto(g.id)} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '14px' }}>🗑️</button>
              </div>
            ))}
          </div>
        )}

        {detalleTab === 'documentos' && (
          <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '32px', textAlign: 'center' }}>
            <div style={{ fontSize: '40px', marginBottom: '16px' }}>📎</div>
            <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '8px', color: '#e8eaf0' }}>Documentos del viaje</div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '20px' }}>Carta de instrucciones, carta porte, póliza de seguro, permisos</div>
            <button style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '8px', padding: '10px 20px', fontSize: '13px', fontWeight: '700' }}>+ Subir documento</button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{ padding: '28px 32px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '28px', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', gap: '4px' }}>
          {[{ id: 'dia', label: 'Hoy' }, { id: 'semana', label: 'Esta semana' }, { id: 'mes', label: 'Este mes' }, { id: 'custom', label: 'Personalizado' }].map(p => (
            <button key={p.id} onClick={() => setPeriodo(p.id)}
              style={{ padding: '8px 16px', borderRadius: '6px', border: `1px solid ${periodo === p.id ? '#00e5a0' : '#222730'}`, background: periodo === p.id ? 'rgba(0,229,160,0.06)' : '#111318', color: periodo === p.id ? '#00e5a0' : '#6b7280', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
              {p.label}
            </button>
          ))}
        </div>
        {periodo === 'custom' && (
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <input type="date" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)}
              style={{ background: '#111318', border: '1px solid #222730', borderRadius: '6px', padding: '8px 12px', color: '#e8eaf0', fontSize: '13px' }} />
            <span style={{ color: '#6b7280' }}>→</span>
            <input type="date" value={fechaFin} onChange={e => setFechaFin(e.target.value)}
              style={{ background: '#111318', border: '1px solid #222730', borderRadius: '6px', padding: '8px 12px', color: '#e8eaf0', fontSize: '13px' }} />
          </div>
        )}
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
          <input value={filtroTexto} onChange={e => setFiltroTexto(e.target.value)} placeholder="Filtrar por carrier, cliente, ruta, unidad, placas, caja..."
            style={{ background: '#111318', border: '1px solid #222730', borderRadius: '6px', padding: '8px 12px', color: '#e8eaf0', fontSize: '13px', width: '260px' }} />
          
          <select value={filtroUsuario} onChange={e => setFiltroUsuario(e.target.value)}
            style={{ background: '#111318', border: '1px solid #222730', borderRadius: '6px', padding: '8px 12px', color: filtroUsuario ? '#8b5cf6' : '#6b7280', fontSize: '13px' }}>
            <option value="">Todos los ejecutivos</option>
            {listaUsuarios.map(u => <option key={u.id} value={u.nombre}>{u.nombre}</option>)}
          </select>
         
        </div>
        <div style={{ display: 'flex', gap: '8px', marginLeft: 'auto' }}>
          <button onClick={exportarCSV} style={{ background: 'transparent', border: '1px solid #222730', color: '#6b7280', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>CSV</button>
          <button onClick={exportarPDF} style={{ background: 'transparent', border: '1px solid #3b82f6', color: '#3b82f6', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>PDF</button>        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
        {[
          { label: 'Total de Viajes', value: totalViajes, color: '#3b82f6' },
          { label: 'Costo Total', value: totalGastosPeríodo > 0 ? `$${totalGastosPeríodo.toLocaleString('es-MX', {maximumFractionDigits:0})}` : '—', color: '#00e5a0' },
          { label: 'Km Recorridos', value: kmTotales > 0 ? kmTotales.toLocaleString() : d.kmTotal.toLocaleString(), color: '#8b5cf6' },
          { label: 'Alertas Totales', value: (alerts || []).length, color: '#f59e0b' },
        ].map((k, i) => (
          <div key={i} style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', borderTop: `2px solid ${k.color}` }}>
            <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', marginBottom: '10px' }}>{k.label}</div>
            <div style={{ fontSize: '32px', fontWeight: '700', color: k.color, lineHeight: 1 }}>{k.value}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
        <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '24px' }}>
          <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '20px', color: '#ffffff' }}>Métricas del Período</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {[
              { label: 'Costo por km', value: costoPorKm !== '—' ? `$${costoPorKm}/km` : '—', color: '#00e5a0' },
              { label: 'Costo promedio por viaje', value: costoPromedio !== '—' ? `$${parseFloat(costoPromedio).toLocaleString('es-MX')} MXN` : '—', color: '#00e5a0' },
              { label: 'Tiempo promedio de viaje', value: d.tiempoPromedio, color: '#f35ff1' },
              { label: 'Espera promedio', value: esperaPromedio, color: '#f0f420' },
              { label: 'Viajes con incidencias', value: `${incidencias}/${totalViajes} (${totalViajes > 0 ? Math.round((incidencias/totalViajes)*100) : 0}%)`, color: '#ef4444' },
            ].map((m, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #222730' }}>
                <span style={{ fontSize: '13px', color: '#9ca3af' }}>{m.label}</span>
                <span style={{ fontSize: '16px', fontWeight: '700', color: m.color }}>{m.value}</span>
              </div>
            ))}
          </div>
        </div>
        <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '24px' }}>
          <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '20px', color: '#ffffff' }}>Motivos de Alerta</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {motivosData.map((m, i) => (
              <div key={i}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                  <span style={{ fontSize: '12px', color: '#9ca3af' }}>{m.motivo}</span>
                  <span style={{ fontSize: '12px', fontWeight: '600', color: m.color }}>{m.cantidad}</span>
                </div>
                <div style={{ height: '6px', background: '#222730', borderRadius: '3px', overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: `${(m.cantidad/total)*100}%`, background: m.color, borderRadius: '3px' }}></div>
                </div>
              </div>
            ))}
            {motivosData.length === 0 && <div style={{ fontSize: '13px', color: '#6b7280', textAlign: 'center', padding: '20px' }}>Sin alertas registradas</div>}
          </div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '24px' }}>
        {[
          { label: 'Por Carrier', campo: 'carrier' },
          { label: 'Por Cliente', campo: 'cliente' },
          { label: 'Por Ejecutivo', campo: 'usuario_nombre' },
          { label: 'Por Conductor', campo: 'conductor' },
          { label: 'Por Ruta', campo: 'ruta' },
        ].map(({ label, campo }) => {
          const datosAgrupados = agrupar(campo);
          return (
            <div key={campo} style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
              <div style={{ padding: '14px 20px', borderBottom: '1px solid #222730' }}>
                <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>{label}</span>
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    {[label.replace('Por ',''), 'Viajes', 'Costo prom.', 'Incidencias'].map(h => (
                      <th key={h} style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1px', color: '#6b7280', padding: '8px 12px', textAlign: 'left', borderBottom: '1px solid #222730', fontWeight: '600' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {datosAgrupados.map((row, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? 'transparent' : '#0d1117' }}>
                      <td style={{ padding: '8px 12px', fontSize: '12px', color: '#e8eaf0', fontWeight: '500' }}>{row.nombre}</td>
                      <td style={{ padding: '8px 12px', fontSize: '12px', color: '#9ca3af' }}>{row.viajes}</td>
                      <td style={{ padding: '8px 12px', fontSize: '12px', color: '#00e5a0', fontFamily: 'monospace' }}>{row.costoPromedio}</td>
                      <td style={{ padding: '8px 12px', fontSize: '12px', color: row.incidencias > 0 ? '#ef4444' : '#00e5a0', fontWeight: '600' }}>{row.incidencias > 0 ? `⚠️ ${row.incidencias}` : '✅ 0'}</td>
                    </tr>
                  ))}
                  {datosAgrupados.length === 0 && (
                    <tr><td colSpan="4" style={{ padding: '16px', textAlign: 'center', color: '#6b7280', fontSize: '12px' }}>Sin datos</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>

      <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
        <div style={{ padding: '14px 20px', borderBottom: '1px solid #222730', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>Viajes del Período</span>
          <span style={{ fontSize: '12px', color: '#6b7280' }}>Haz clic en un viaje para ver el diario completo</span>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {['Viaje', 'Carrier', 'Ejecutivo', 'Cliente', 'Ruta', 'Gastos'].map(h => (
                <th key={h} style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', padding: '12px 20px', textAlign: 'left', borderBottom: '1px solid #222730', fontWeight: '600' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {viajesFiltrados.map((v, i) => {
              const gastoTotal = (v.gastos || []).reduce((a, g) => a + parseFloat(g.monto || 0), 0);
              return (
                <tr key={v.id} onClick={() => { setViajeDetalle(v); setDetalleTab('bitacora'); }}
                  style={{ background: i % 2 === 0 ? 'transparent' : '#0d1117', cursor: 'pointer' }}
                  onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,229,160,0.04)'}
                  onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? 'transparent' : '#0d1117'}>
                  <td style={{ padding: '12px 20px', fontFamily: 'monospace', fontSize: '12px', color: '#00e5a0' }}>{v.numero}</td>
                  <td style={{ padding: '12px 20px', fontSize: '13px', color: '#e8eaf0' }}>{v.carrier}</td>
                  <td style={{ padding: '12px 20px', fontSize: '12px', color: '#e8eaf0', fontWeight: '500' }}>{v.usuario_nombre || '—'}</td>
                  <td style={{ padding: '12px 20px', fontSize: '12px', color: '#9ca3af' }}>{v.cliente || '—'}</td>
                  <td style={{ padding: '12px 20px', fontSize: '12px', color: '#9ca3af' }}>{v.ruta}</td>
                  <td style={{ padding: '12px 20px', fontSize: '12px', color: '#00e5a0', fontWeight: '600' }}>${gastoTotal.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</td>
                  
                </tr>
              );
            })}
            {viajesFiltrados.length === 0 && (
              <tr><td colSpan="6" style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin viajes para los filtros seleccionados</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}